import React from "react";

import SectionSidebar, { ISectionGroup, SectionIcon } from "src/components/SectionSidebar/SectionSidebar";

import { MANAGE_COURSE_SECTIONS } from "./manage-course-sections";

interface IProps {
  courseTitle?: string;
  clubName?: string;
  clubLogoUrl?: string;
  courseUrl: string;
  registrantLabel: string;
  activeTab: number;
  onSelect(index: number): void;
  mobileOpen: boolean;
  onMobileClose(): void;
}

const CourseManageSidebar: React.FC<IProps> = ({
  courseTitle,
  clubName,
  clubLogoUrl,
  courseUrl,
  registrantLabel,
  activeTab,
  onSelect,
  mobileOpen,
  onMobileClose,
}) => {
  const groups: ISectionGroup[] = [
    {
      label: "Registration",
      items: MANAGE_COURSE_SECTIONS.filter((section) => section.group === "Registration").map((section) => ({
        id: String(section.tabIndex),
        label: section.id === "registrants" ? registrantLabel : "Waitlist",
        icon: <SectionIcon name={section.icon} />,
      })),
    },
    {
      label: "Financials",
      items: MANAGE_COURSE_SECTIONS.filter((section) => section.group === "Financials").map((section) => ({
        id: String(section.tabIndex),
        label: "Transactions",
        icon: <SectionIcon name={section.icon} />,
      })),
    },
  ];

  return (
    <SectionSidebar
      storageKey="eagerdog.manageCourseSidebarCollapsed"
      menuLabel="Course menu"
      eyebrow={clubName || courseTitle}
      header={{
        title: courseTitle || "Course",
        imageUrl: clubLogoUrl,
        imageAlt: clubName || "Club logo",
        fallbackName: clubName || courseTitle,
        linkTo: courseUrl,
        linkLabel: "View Course",
      }}
      groups={groups}
      activeId={String(activeTab)}
      onSelect={(id) => onSelect(Number(id))}
      mobileOpen={mobileOpen}
      onMobileClose={onMobileClose}
    />
  );
};

export default CourseManageSidebar;
